import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const proceduceService = {
  get: async (search, page, limit, token) => {
    const response = await https.get(
      `${API_ROUTES.PROCEDUCE.GET}?page=${page}&limit=${limit}&search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_all: async (search, token) => {
    const response = await https.get(
      `${API_ROUTES.PROCEDUCE.GET}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_id: async (id, token) => {
    const response = await https.get(
      `${API_ROUTES.PROCEDUCE.GET_BY_ID}/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  create: async (data, token) => {
    const response = await https.post(`${API_ROUTES.PROCEDUCE.CREATE}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  update: async (id, data, token) => {
    const response = await https.put(
      `${API_ROUTES.PROCEDUCE.UPDATE}/${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  delete: async (id, token) => {
    const response = await https.delete(
      `${API_ROUTES.PROCEDUCE.GET_BY_ID}/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
